import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

// Both dark and light themes uses the same shadow in Figma.
const BOX_SHADOW = '0px 0px 20px rgba(0, 0, 0, 0.1)'
const BORDER_RADIUS = '1.5rem'

const getBackgroundColor = (props: Dict) =>
  mode('rw1.body.light.clean', 'rw1.secondary.dark.0')(props)

export const Container: ComponentStyleConfig = {
  variants: {
    elevated: (props: Dict) => ({
      backgroundColor: getBackgroundColor(props),
      borderTopRadius: BORDER_RADIUS,
      boxShadow: BOX_SHADOW,
    }),
    absolute: (props: Dict) => ({
      backgroundColor: getBackgroundColor(props),
      boxShadow: BOX_SHADOW,
      borderRadius: BORDER_RADIUS,
      position: 'absolute',
    }),
    elevatedFullRadius: (props: Dict) => ({
      backgroundColor: getBackgroundColor(props),
      borderRadius: BORDER_RADIUS,
      boxShadow: BOX_SHADOW,
    }),
  },
}
